
import { useNavigate } from "react-router-dom";
function UserModel({ patient }) {
  const navigate = useNavigate();  
  const handleOpenReporting = () => {
   navigate(`/report/${patient?.id}`, {
      state: {
        compareData: patient,
        openReport: true
      }
    });
  };
  return (
    <button title="User" onClick={handleOpenReporting}>
      Open Report
    </button>
  );
}
export default UserModel;